module.exports = __webpack_public_path__ + "6d6445442453974a648323104ad68d81.png";